import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Level1 from './level1';
import Level2 from './level2';
import RunBanner from '../needs_attention/month_run/run_banner';
import useActiveRun from '../needs_attention/month_run/use_active_run';
import { initial_l1_state } from './params';
import ModeBadge from '../email_send/mode_badge';
import SendDialog from '../email_send/send_dialog';
import useSendMode from '../email_send/use_send_mode';

/* Overview tab: all-teacher table, per-teacher breakdown. */
const OverviewTab = ({
  pay_month,
  month_label,
  initial_needs_review,
  on_deep_link_consumed,
  on_open_needs_attention,
  on_open_penalties,
  on_error,
  on_notify
}) => {
  const location = useLocation();
  const active_run = useActiveRun(pay_month);
  const [selected, setSelected] = useState(null);
  const [send_target, setSendTarget] = useState(null); // {all} | {teacher_uuids, label}
  const send_mode = useSendMode();
  const [l1_state, setL1State] = useState(() =>
    initial_l1_state(initial_needs_review, location.search)
  );

  useEffect(() => {
    if (on_deep_link_consumed) on_deep_link_consumed();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelected(null);
  }, [pay_month]);

  if (!pay_month) return null;
  const banner = <RunBanner run={active_run} on_open={on_open_needs_attention} />;
  if (selected) {
    return (
      <>
        {banner}
        <Level2
          pay_month={pay_month}
          month_label={month_label}
          teacher={selected}
          on_back={() => setSelected(null)}
          on_error={on_error}
          on_open_penalties={on_open_penalties}
        />
      </>
    );
  }
  return (
    <>
      {banner}
      <div className="tp-ov-stmt-link">
        <Link className="tp-link" to={`/teacher-payments/statement?month=${pay_month}`}>
          Statement and compare
        </Link>
        <span className="tp-muted">
          {' '}
          · download the invoice-sheet statement, check your sheet against it
        </span>
      </div>
      <div className="tp-es-strip">
        <ModeBadge mode={send_mode.mode} />
        <button
          type="button"
          className="tp-btn-out"
          onClick={() => setSendTarget({ all: true, label: 'every verified teacher' })}
        >
          Send payment breakdown (all verified)
        </button>
        <span className="tp-es-strip-note">
          Only verified (closed) teacher-months are sent. You see who gets it before anything goes.
        </span>
      </div>
      <Level1
        on_send_breakdown={setSendTarget}
        pay_month={pay_month}
        month_label={month_label}
        view_state={l1_state}
        on_view_state={setL1State}
        on_error={on_error}
        on_notify={on_notify}
        on_open_teacher={setSelected}
      />
      {send_target ? (
        <SendDialog
          title={`Send payment breakdown · ${month_label} · ${send_target.label}`}
          target={{ type: 'breakdown', pay_month, ...send_target }}
          on_close={() => {
            setSendTarget(null);
            send_mode.reload();
          }}
          on_error={on_error}
          on_notify={on_notify}
        />
      ) : null}
    </>
  );
};

export default OverviewTab;
